<template>
  <div class="items-list-header-bar">
    <div v-show="totalLoading > 1">
      <button
        v-if="!withoutGroupStructure"
        class="items-list-action-chip-add"
        :disabled="withoutGroupStructure"
        @click="$emit('add-group')"
      >
        <span class="items-list-tooltip-wrapper">
          <i class="fa-solid fa-plus" aria-hidden="true"></i>
          <span class="items-list-tooltip-box">Adicionar grupo</span>
        </span>
        <span>Grupo</span>
      </button>

      <button
        v-if="!withoutGroupStructure"
        class="items-list-action-chip-add"
        :disabled="withoutGroupStructure"
        @click="$emit('open-manage-groups')"
      >
        <i class="fa-sharp fa-solid fa-grip-dots-vertical"></i>
        <span>Grupo e Subgrupos</span>
      </button>

      <button
        v-if="!withoutGroupStructure"
        class="items-list-action-chip-add items-list-action-chip-model"
        :disabled="withoutGroupStructure"
        @click="$emit('open-templates')"
      >
        <i class="fa-duotone fa-solid fa-folder-tree"></i>
        <span>Modelo</span>
      </button>

      <div class="side-by-side">
        <WithoutGroupSubgroupCheckbox
          :rentId="rent.id"
          :disabled="!selectedPeriod.period"
          :periodRentId="selectedPeriod.period ? selectedPeriod.period.id : ''"
        />
      </div>
    </div>

    <div
      class="items-list-div-loading"
      v-show="!showGroups && loading && totalLoading > 1"
    >
      <vue-loading
        type="bubbles"
        color="#D98621"
        :size="{ width: '26px', height: '26px' }"
      ></vue-loading>
    </div>

    <div class="items-list-filter">
      <b-row>
        <b-col v-if="totalLoading > 1">
          <div class="items-list-text-right">
            <div class="items-list-div-total side-by-side items-list-text-center">
              Total <b>{{ totalProducts }}</b> registros
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import WithoutGroupSubgroupCheckbox from "../WithoutGroupSubgroupCheckbox.vue";

export default {
  name: "ItemsRentActionBar",
  components: {
    WithoutGroupSubgroupCheckbox,
  },
  props: {
    rent: { type: Object, required: true },
    selectedPeriod: { type: Object, default: () => ({}) },
    withoutGroupStructure: { type: Boolean, default: false },
    totalLoading: { type: Number, default: 1 },
    loading: { type: Boolean, default: false },
    showGroups: { type: Boolean, default: false },
    totalProducts: { type: Number, default: 0 },
  },
};
</script>

<style scoped>
.items-list-header-bar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
  margin-bottom: 10px;
  margin-left: 2px;
}

.items-list-filter {
  margin-left: auto;
  width: 200px;
  margin-bottom: -12px;
}

.items-list-text-center {
  text-align: center;
}

.items-list-div-total {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #e6e7eb;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  margin-bottom: 10px;
  width: 160px;
  display: block;
  margin-left: auto;
  margin-bottom: 12px;
}

.items-list-div-loading {
  margin: 8px 10px 10px 10px;
}

.items-list-action-chip-add {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 9px;
  border-radius: 9999px;
  border: none;
  background: #0a54f5;
  color: #fff;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
  margin-right: 8px;
}

.items-list-action-chip-add:disabled {
  background: #e3e5ed !important;
  color: #fff;
  cursor: not-allowed;
  box-shadow: none;
}

.items-list-action-chip-add:disabled i {
  color: #fff;
}

.items-list-action-chip-add:disabled:hover {
  background: #e3e5ed;
}

.items-list-action-chip-model {
  background: #009183;
}

.items-list-action-chip-model:hover {
  background: #007a6e;
}

.items-list-tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.items-list-tooltip-box {
  position: absolute;
  white-space: nowrap;
  background: rgba(0, 0, 0, 0.87);
  color: #fff;
  padding: 6px 8px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 300;
  opacity: 0;
  pointer-events: none;
  z-index: 60;
  left: 50%;
  bottom: 100%;
  transform: translateX(-50%) translateY(6px);
  transition: opacity 0.12s ease, transform 0.12s ease;
}

.items-list-tooltip-wrapper:hover .items-list-tooltip-box {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

.items-list-tooltip-box::after {
  content: "";
  position: absolute;
  border: 6px solid transparent;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-top-color: rgba(0, 0, 0, 0.87);
}
</style>
